export const getTimeFromStart = (startTime: number) => {
  const timestamp = new Date().getTime();
  const diff = timestamp - startTime * 1000;
  const minutes = diff / 60000;
  return `${parseInt(String(minutes))}`; // return minutes
};
